import Route from '@ember/routing/route';

export default class AboutOurDataRoute extends Route {}
